import SrDocumentRoutes from 'components/routes/SrDocumentRoutes'
import React from 'react'

const SrDocumentHome = () => {
  return <SrDocumentRoutes />
}

export default SrDocumentHome
